<template>
    <div>
        <h3
            v-if="!editable"
            class="font-semibold mb-8"
            v-text="title || $lang.get('Attributes')"
        />
        <p
            v-if="editable && required"
            class="text-sm text-gray-500 mb-4 italic"
            v-text="$lang.get('At least one attribute must be selected')"
        />
        <div class="flex flex-col gap-y-10">
            <div v-for="group in attributeGroups" :key="group.id">
                <h5 class="mb-4" v-text="group.name" />
                <div class="flex flex-wrap gap-2">
                    <Attribute
                        v-for="attribute in group.attributes"
                        :text="attribute.name"
                        :editable="editable"
                        :selected="
                            editable && modelValue.includes(attribute.id)
                        "
                        @click="editable ? selectAttribute(attribute.id) : null"
                        ref="attribute"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Attribute from '@/Components/Elements/Attribute.vue'
export default {
    name: 'Attributes',

    components: {
        Attribute,
    },

    emits: ['update:modelValue'],

    expose: ['focusMethod'],

    props: {
        attributeGroups: {
            type: Array,
            required: true,
        },
        modelValue: {
            type: Array,
            required: false,
        },
        editable: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: false,
        },
        required: {
            type: Boolean,
            default: true,
        },
    },

    mounted() {
        if (this.editable && this.modelValue.length) {
            this.filterAttributes()
        }
    },

    computed: {
        /**
         * Get all the ids of the groups attributes
         */
        availableAttributeIds() {
            if (this.editable) {
                return this.attributeGroups.reduce((ids, group) => {
                    group.attributes.forEach((attribute) => {
                        ids.push(attribute.id)
                    })
                    return ids
                }, [])
            }
            return []
        },
    },
    methods: {
        selectAttribute(attributeID) {
            if (this.modelValue.includes(attributeID)) {
                this.$emit(
                    'update:modelValue',
                    this.modelValue.filter((value) => value !== attributeID)
                )
            } else {
                this.$emit('update:modelValue', [
                    ...this.modelValue,
                    attributeID,
                ])
            }
        },

        focusMethod() {
            if (this.editable) {
                this.$refs.attribute[0].focusMethod()
            }
        },

        /**
         * Go through the attribute and ensure that they exists in the options,
         * otherwise they should not be saved since they are not selectable for this modelClass
         */
        filterAttributes() {
            // Only preserve the ids that exists in the availableAttributeIds array
            let filteredValues = this.modelValue.filter((id) =>
                this.availableAttributeIds.includes(id)
            )

            if (filteredValues.length != this.modelValue.length) {
                this.$emit('update:modelValue', filteredValues)
            }
        },
    },
}
</script>
